export const SHP_FORMS: any[] = [
    {
        "columns" : [ {
            "name" : "shipmentMethodTypeId",
            "title" : "Shipment Method Type ID"
        }, {
            "name" : "description",
            "title" : "Description"
        }, {
            "name" : "sequenceNum",
            "title" : "Sequence Num"
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "ListShipmentMethodTypes",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ShippingForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Shipment Method Type ID",
            "type" : "HYPERLINK",
            "target" : "ListShipmentMethodTypes",
            "name" : "shipmentMethodTypeId",
            "width" : "",
            "parameterList" : [ {
            "name" : "shipmentMethodTypeId"
            } ],
            "style" : "",
            "id" : "ListShipmentMethodTypes_shipmentMethodTypeId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "event":"master-detail",
            "formData":{
                "formName":"EditShipmentMethodType",
                "formLocation":"component://kwikstore/widget/ShippingForms.xml",
                "endPoint":"listImageGallery",
                "link":"/admin/shipping/shipment-method/${shipmentMethodTypeId}"
              }
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "description",
            "description" : "",
            "style" : "",
            "id" : "ListShipmentMethodTypes_description",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "sequenceNum",
            "description" : "",
            "style" : "",
            "id" : "ListShipmentMethodTypes_sequenceNum",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Remove",
            "parameterList" : [ {
            "name" : "shipmentMethodTypeId"
            } ],
            "id" : "ListShipmentMethodTypes_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "deleteShipmentMethodType"
        } ],
        "target" : ""
    },
    {
        "formName" : "EditShipmentMethodType",
        "altTarget" : [ {
            "useWhen" : "shipmentMethodType!=null",
            "targetExdr" : {
            "chars" : "updateShipmentMethodType",
            "hint" : 20,
            "empty" : false,
            "original" : "updateShipmentMethodType"
            }
        } ],
        "formLocation" : "component://kwikstore/widget/ShippingForms.xml",
        "type" : "single",
        "fields" : [ {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "required",
            "title" : "Shipment Method Type ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "shipmentMethodTypeId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditShipmentMethodType_shipmentMethodTypeId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "description",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditShipmentMethodType_description",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Sequence Num",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "sequenceNum",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditShipmentMethodType_sequenceNum",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditShipmentMethodType",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "EditShipmentMethodType_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Submit",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createShipmentMethodType"
    },
    {
        "columns" : [ {
            "name" : "quantityBreakId",
            "title" : "Quantity Break ID"
        }, {
            "name" : "quantityBreakTypeId",
            "title" : "Type"
        }, {
            "name" : "fromQuantity",
            "title" : "From Quantity"
        }, {
            "name" : "thruQuantity",
            "title" : "Through Quantity"
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "ListQuantityBreaks",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ShippingForms.xml",
        "type" : "list",
        "fields" : [ {
            "image" : "",
            "fieldHelpText" : "",
            "alternate" : "",
            "description" : "",
            "title" : "Quantity Break ID",
            "type" : "HYPERLINK",
            "target" : "ListQuantityBreaks",
            "name" : "quantityBreakId",
            "width" : "",
            "parameterList" : [ {
            "name" : "quantityBreakId"
            } ],
            "style" : "",
            "id" : "ListQuantityBreaks_quantityBreakId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quantityBreakTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListQuantityBreaks_quantityBreakTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromQuantity",
            "description" : "",
            "style" : "",
            "id" : "ListQuantityBreaks_fromQuantity",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruQuantity",
            "description" : "",
            "style" : "",
            "id" : "ListQuantityBreaks_thruQuantity",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Remove",
            "parameterList" : [ {
            "name" : "quantityBreakId"
            } ],
            "id" : "ListQuantityBreaks_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "deleteQuantityBreak"
        } ],
        "target" : ""
    },
    {
        "formName" : "EditQuantityBreak",
        "altTarget" : [ {
            "useWhen" : "quantityBreak!=null",
            "targetExdr" : {
            "chars" : "updateQuantityBreak",
            "hint" : 20,
            "empty" : false,
            "original" : "updateQuantityBreak"
            }
        } ],
        "targets":{
            "createTarget" : "createQuantityBreak",
            "updateTarget" : "updateQuantityBreak"
        },
        "formLocation" : "component://kwikstore/widget/ShippingForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "quantityBreakId",
            "action" : "",
            "id" : "EditQuantityBreak_quantityBreakId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditQuantityBreak",
            "options" : [ {
            "description" : "Price Component Order Value Break",
            "key" : "ORDER_VALUE"
            }, {
            "description" : "Price Component Quantity Break",
            "key" : "QUANTITY"
            }, {
            "description" : "Shipping Price Break",
            "key" : "SHIP_PRICE"
            }, {
            "description" : "Shipping Quantity Break",
            "key" : "SHIP_QUANTITY"
            }, {
            "description" : "Shipping Weight Break",
            "key" : "SHIP_WEIGHT"
            } ],
            "disabled" : "false",
            "id" : "EditQuantityBreak_quantityBreakTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "quantityBreakTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "From Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "fromQuantity",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditQuantityBreak_fromQuantity",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Through Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "thruQuantity",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditQuantityBreak_thruQuantity",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditQuantityBreak",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "EditQuantityBreak_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Submit",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createQuantityBreak"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "partyId", "roleTypeId", "sequenceNumber", "carrierServiceCode", "editLink", "deleteLink" ]
        } ],
        "columns" : [ {
            "name" : "shipmentMethodTypeId",
            "title" : "Shipment Method Type ID"
        }, {
            "name" : "partyId",
            "title" : "Party ID"
        }, {
            "name" : "roleTypeId",
            "title" : "Role Type ID"
        }, {
            "name" : "sequenceNumber",
            "title" : "Seq. Num."
        }, {
            "name" : "carrierServiceCode",
            "title" : "Carrier Service Code"
        }, {
            "name" : "editLink",
            "title" : " "
        }, {
            "name" : "deleteLink",
            "title" : " "
        } ],
        "formName" : "ListCarrierShipmentMethods",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ShippingForms.xml",
        "type" : "list",
        "fields" : [ {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "shipmentMethodTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListCarrierShipmentMethods_shipmentMethodTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyId",
            "description" : "",
            "style" : "",
            "id" : "ListCarrierShipmentMethods_partyId",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "roleTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListCarrierShipmentMethods_roleTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "sequenceNumber",
            "description" : "",
            "style" : "",
            "id" : "ListCarrierShipmentMethods_sequenceNumber",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "carrierServiceCode",
            "description" : "",
            "style" : "",
            "id" : "ListCarrierShipmentMethods_carrierServiceCode",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "editLink",
            "alternate" : "",
            "description" : "Edit",
            "parameterList" : [ {
            "name" : "shipmentMethodTypeId"
            }, {
            "name" : "partyId"
            }, {
            "name" : "roleTypeId"
            } ],
            "id" : "ListCarrierShipmentMethods_editLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "ListCarrierShipmentMethods"
        }, {
            "image" : "",
            "width" : "",
            "name" : "deleteLink",
            "alternate" : "",
            "description" : "Remove",
            "parameterList" : [ {
            "name" : "shipmentMethodTypeId"
            }, {
            "name" : "partyId"
            }, {
            "name" : "roleTypeId"
            } ],
            "id" : "ListCarrierShipmentMethods_deleteLink",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "deleteCarrierShipmentMethod"
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "shipmentMethodTypeId", "shipmentMethodTypeId", "partyId", "partyId", "partyId", "roleTypeId", "roleTypeId", "roleTypeId", "sequenceNumber", "carrierServiceCode", "submitButton" ]
        } ],
        "formName" : "EditCarrierShipmentMethod",
        "altTarget" : [ {
            "useWhen" : "carrierShipmentMethod!=null",
            "targetExdr" : {
            "chars" : "updateCarrierShipmentMethod",
            "hint" : 20,
            "empty" : false,
            "original" : "updateCarrierShipmentMethod"
            }
        } ],
        "formLocation" : "component://kwikstore/widget/ShippingForms.xml",
        "type" : "single",
        "fields" : [ {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Shipment Method Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditCarrierShipmentMethod",
            "options" : [ {
            "description" : "1Day Freight [FIRST_DAY_FR]",
            "key" : "FIRST_DAY_FR"
            }, {
            "description" : "2Day AM [SECOND_DAY_AM]",
            "key" : "SECOND_DAY_AM"
            }, {
            "description" : "2Day Freight [SECOND_DAY_FR]",
            "key" : "SECOND_DAY_FR"
            }, {
            "description" : "3Day Freight [THIRD_DAY_FR]",
            "key" : "THIRD_DAY_FR"
            }, {
            "description" : "Air [AIR]",
            "key" : "AIR"
            }, {
            "description" : "Europe First Priority [EUROPE_FI_PRIORITY]",
            "key" : "EUROPE_FI_PRIORITY"
            }, {
            "description" : "Express [EXPRESS]",
            "key" : "EXPRESS"
            }, {
            "description" : "Express 10.30 AM [EXP_10_30_AM]",
            "key" : "EXP_10_30_AM"
            }, {
            "description" : "Express International [EXP_INTERNATIONAL]",
            "key" : "EXP_INTERNATIONAL"
            }, {
            "description" : "Express Saturday [EXP_SATURDAY]",
            "key" : "EXP_SATURDAY"
            }, {
            "description" : "Express Saver [EXPRESS_SAVER]",
            "key" : "EXPRESS_SAVER"
            }, {
            "description" : "Fedex Freight [FEDEX_FREIGHT]",
            "key" : "FEDEX_FREIGHT"
            }, {
            "description" : "Fedex International Ground  [FEDEX_INT_GROUND]",
            "key" : "FEDEX_INT_GROUND"
            }, {
            "description" : "Fedex National Freight [FEDEX_NATIONAL_FR]",
            "key" : "FEDEX_NATIONAL_FR"
            }, {
            "description" : "First Class [FIRST_CLASS]",
            "key" : "FIRST_CLASS"
            }, {
            "description" : "First Class International [FC_INTERNATIONAL]",
            "key" : "FC_INTERNATIONAL"
            }, {
            "description" : "First Overnight [FI_OVERNIGHT]",
            "key" : "FI_OVERNIGHT"
            }, {
            "description" : "Ground [GROUND]",
            "key" : "GROUND"
            }, {
            "description" : "Ground Home Delivery [GROUND_HOME]",
            "key" : "GROUND_HOME"
            }, {
            "description" : "Guaranteed Next Day [NEXT_DAY]",
            "key" : "NEXT_DAY"
            }, {
            "description" : "International Economy [INTERNAT_ECON]",
            "key" : "INTERNAT_ECON"
            }, {
            "description" : "International Economy Freight [INTERNAT_ECON_FR]",
            "key" : "INTERNAT_ECON_FR"
            }, {
            "description" : "International Express [INT_EXPRESS]",
            "key" : "INT_EXPRESS"
            }, {
            "description" : "International First [INTERNAT_FI]",
            "key" : "INTERNAT_FI"
            }, {
            "description" : "International Priority [INTERNAT_PRI]",
            "key" : "INTERNAT_PRI"
            }, {
            "description" : "International Priority Freight [INTERNAT_PRI_FR]",
            "key" : "INTERNAT_PRI_FR"
            }, {
            "description" : "Library [LIBRARY]",
            "key" : "LIBRARY"
            }, {
            "description" : "Local Delivery [LOCAL_DELIVERY]",
            "key" : "LOCAL_DELIVERY"
            }, {
            "description" : "Media Mail [MEDIA_MAIL]",
            "key" : "MEDIA_MAIL"
            }, {
            "description" : "Next Afternoon [NEXT_PM]",
            "key" : "NEXT_PM"
            }, {
            "description" : "Next Day Air [NEXT_DAY_AIR]",
            "key" : "NEXT_DAY_AIR"
            }, {
            "description" : "Next Day Air Early A.M. [NEXT_DAY_AIR_AM]",
            "key" : "NEXT_DAY_AIR_AM"
            }, {
            "description" : "Next Day Air Saver [NEXT_DAY_AIR_SA]",
            "key" : "NEXT_DAY_AIR_SA"
            }, {
            "description" : "Next Morning [NEXT_AM]",
            "key" : "NEXT_AM"
            }, {
            "description" : "No Shipping [NO_SHIPPING]",
            "key" : "NO_SHIPPING"
            }, {
            "description" : "Priority [PRIORITY]",
            "key" : "PRIORITY"
            }, {
            "description" : "Priority International [PR_INTERNATIONAL]",
            "key" : "PR_INTERNATIONAL"
            }, {
            "description" : "Priority Overnight [PR_OVERNIGHT]",
            "key" : "PR_OVERNIGHT"
            }, {
            "description" : "Same Day [SAME_DAY]",
            "key" : "SAME_DAY"
            }, {
            "description" : "Saver [SAVER]",
            "key" : "SAVER"
            }, {
            "description" : "Second Day [SECOND_DAY]",
            "key" : "SECOND_DAY"
            }, {
            "description" : "Second Day Air [SECOND_DAY_AIR]",
            "key" : "SECOND_DAY_AIR"
            }, {
            "description" : "Second Day Air Early A.M.   [SECOND_DAY_AIR_AM]",
            "key" : "SECOND_DAY_AIR_AM"
            }, {
            "description" : "Smart Post [SMART_POST]",
            "key" : "SMART_POST"
            }, {
            "description" : "Standard [STANDARD]",
            "key" : "STANDARD"
            }, {
            "description" : "Standard Overnight [ST_OVERNIGHT]",
            "key" : "ST_OVERNIGHT"
            }, {
            "description" : "Standard Post [STANDARD_POST]",
            "key" : "STANDARD_POST"
            }, {
            "description" : "Third Day [THIRD_DAY]",
            "key" : "THIRD_DAY"
            }, {
            "description" : "Three-Day Select [THIRD_DAY_AIR_SEL]",
            "key" : "THIRD_DAY_AIR_SEL"
            }, {
            "description" : "Worldwide ExpeditedSM [WORLDWIDE_EXPEDITED]",
            "key" : "WORLDWIDE_EXPEDITED"
            }, {
            "description" : "Worldwide Express Plus [WORLDWIDE_EXPR_PLUS]",
            "key" : "WORLDWIDE_EXPR_PLUS"
            }, {
            "description" : "Worldwide ExpressSM [WORLDWIDE_EXPRESS]",
            "key" : "WORLDWIDE_EXPRESS"
            } ],
            "disabled" : "false",
            "id" : "EditCarrierShipmentMethod_shipmentMethodTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "shipmentMethodTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditCarrierShipmentMethod",
            "id" : "EditCarrierShipmentMethod_partyId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupPartyName",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "partyId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "partyId",
            "style" : "",
            "id" : "EditCarrierShipmentMethod_partyId",
            "title" : "Party ID",
            "type" : "LOOKUP"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Role Type ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "CARRIER",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditCarrierShipmentMethod",
            "options" : [ {
            "description" : "Account",
            "key" : "ACCOUNT"
            }, {
            "description" : "Account Lead",
            "key" : "ACCOUNT_LEAD"
            }, {
            "description" : "Accountant",
            "key" : "ACCOUNTANT"
            }, {
            "description" : "Addressee",
            "key" : "ADDRESSEE"
            }, {
            "description" : "Administrator",
            "key" : "ADMIN"
            }, {
            "description" : "Affiliate",
            "key" : "AFFILIATE"
            }, {
            "description" : "Agent",
            "key" : "AGENT"
            }, {
            "description" : "Approver",
            "key" : "APPROVER"
            }, {
            "description" : "Association",
            "key" : "ASSOCIATION"
            }, {
            "description" : "Automated Agent",
            "key" : "AUTOMATED_AGENT_ROLE"
            }, {
            "description" : "Bill-From-Vendor",
            "key" : "BILL_FROM_VENDOR"
            }, {
            "description" : "Bill-To Customer",
            "key" : "BILL_TO_CUSTOMER"
            }, {
            "description" : "Blind Copy",
            "key" : "BCC"
            }, {
            "description" : "Budget Application",
            "key" : "BUDGET_APPL"
            }, {
            "description" : "Budget Approver",
            "key" : "BUDGET_APPRV"
            }, {
            "description" : "Budget Manager",
            "key" : "BUDGET_MGR"
            }, {
            "description" : "Budget Reviewer",
            "key" : "BUDGET_RVR"
            }, {
            "description" : "Budget Roles Group (not to be assigned to parties)",
            "key" : "BUDGET"
            }, {
            "description" : "Bulk Customer",
            "key" : "BULK_CUSTOMER"
            }, {
            "description" : "Buyer",
            "key" : "BUYER"
            }, {
            "description" : "Calendar",
            "key" : "CALENDAR_ROLE"
            }, {
            "description" : "Calendar Attendee",
            "key" : "CAL_ATTENDEE"
            }, {
            "description" : "Calendar Delegate",
            "key" : "CAL_DELEGATE"
            }, {
            "description" : "Calendar Host",
            "key" : "CAL_HOST"
            }, {
            "description" : "Calendar Member",
            "key" : "ICAL_MEMBER"
            }, {
            "description" : "Calendar Organizer",
            "key" : "CAL_ORGANIZER"
            }, {
            "description" : "Calendar Owner",
            "key" : "CAL_OWNER"
            }, {
            "description" : "Carbon Copy",
            "key" : "CC"
            }, {
            "description" : "Carrier",
            "key" : "CARRIER"
            }, {
            "description" : "Cashier",
            "key" : "CASHIER"
            }, {
            "description" : "Client",
            "key" : "CLIENT"
            }, {
            "description" : "Client Analyst",
            "key" : "CLIENT_ANALYST"
            }, {
            "description" : "Client Billing",
            "key" : "CLIENT_BILLING"
            }, {
            "description" : "Client Manager",
            "key" : "CLIENT_MANAGER"
            }, {
            "description" : "Communication Participant",
            "key" : "COMMEVENT_ROLE"
            }, {
            "description" : "Competitor",
            "key" : "COMPETITOR"
            }, {
            "description" : "Consumer",
            "key" : "CONSUMER"
            }, {
            "description" : "Contact",
            "key" : "CONTACT"
            }, {
            "description" : "Content Administrator",
            "key" : "CONTENT_ADMIN"
            }, {
            "description" : "Content Author",
            "key" : "CONTENT_AUTHOR"
            }, {
            "description" : "Content Editor",
            "key" : "CONTENT_EDITOR"
            }, {
            "description" : "Content Guest",
            "key" : "CONTENT_GUEST"
            }, {
            "description" : "Content Member",
            "key" : "CONTENT"
            }, {
            "description" : "Content Publisher",
            "key" : "CONTENT_PUBLISHER"
            }, {
            "description" : "Content User",
            "key" : "CONTENT_USER"
            }, {
            "description" : "Contractor",
            "key" : "CONTRACTOR"
            }, {
            "description" : "Customer",
            "key" : "CUSTOMER"
            }, {
            "description" : "Department",
            "key" : "DEPARTMENT"
            }, {
            "description" : "Distribution Channel",
            "key" : "DISTRIBUTION_CHANNEL"
            }, {
            "description" : "Distributor",
            "key" : "DISTRIBUTOR"
            }, {
            "description" : "Division",
            "key" : "DIVISION"
            }, {
            "description" : "Email Administrator",
            "key" : "EMAIL_ADMIN"
            }, {
            "description" : "Employee",
            "key" : "EMPLOYEE"
            }, {
            "description" : "Employer",
            "key" : "EMPLOYER"
            }, {
            "description" : "End-User Customer",
            "key" : "END_USER_CUSTOMER"
            }, {
            "description" : "Family Member",
            "key" : "FAMILY_MEMBER"
            }, {
            "description" : "Fixed Asset Maint Assignee",
            "key" : "FAM_ASSIGNEE"
            }, {
            "description" : "Government Agency",
            "key" : "GOV_AGENCY"
            }, {
            "description" : "Hosting Server",
            "key" : "HOSTING_SERVER"
            }, {
            "description" : "Household",
            "key" : "HOUSEHOLD"
            }, {
            "description" : "ISP",
            "key" : "ISP"
            }, {
            "description" : "Image Approver",
            "key" : "IMAGEAPPROVER"
            }, {
            "description" : "Internal Organization",
            "key" : "INTERNAL_ORGANIZATIO"
            }, {
            "description" : "Lead",
            "key" : "LEAD"
            }, {
            "description" : "Limited Administrator",
            "key" : "LTD_ADMIN"
            }, {
            "description" : "Logged In",
            "key" : "LOGGEDIN"
            }, {
            "description" : "Main Role",
            "key" : "MAIN_ROLE"
            }, {
            "description" : "Maintenance Manager or Supervisor",
            "key" : "FAM_MANAGER"
            }, {
            "description" : "Maintenance Supplier or Service",
            "key" : "FAM_SUPPLIER"
            }, {
            "description" : "Maintenance Worker",
            "key" : "FAM_WORKER"
            }, {
            "description" : "Manager",
            "key" : "MANAGER"
            }, {
            "description" : "Manufacturer",
            "key" : "MANUFACTURER"
            }, {
            "description" : "Not Applicable",
            "key" : "_NA_"
            }, {
            "description" : "Order Clerk",
            "key" : "ORDER_CLERK"
            }, {
            "description" : "Organization",
            "key" : "ORGANIZATION_ROLE"
            }, {
            "description" : "Organization Unit",
            "key" : "ORGANIZATION_UNIT"
            }, {
            "description" : "Originator",
            "key" : "ORIGINATOR"
            }, {
            "description" : "Other Internal",
            "key" : "OTHER_INTERNAL_ORGAN"
            }, {
            "description" : "Other Organization Unit",
            "key" : "OTHER_ORGANIZATION_U"
            }, {
            "description" : "Owner",
            "key" : "OWNER"
            }, {
            "description" : "Packer",
            "key" : "PACKER"
            }, {
            "description" : "Parent Organization",
            "key" : "PARENT_ORGANIZATION"
            }, {
            "description" : "Partner",
            "key" : "PARTNER"
            }, {
            "description" : "Person",
            "key" : "PERSON_ROLE"
            }, {
            "description" : "Picker",
            "key" : "PICKER"
            }, {
            "description" : "Placing Customer",
            "key" : "PLACING_CUSTOMER"
            }, {
            "description" : "Product Owner",
            "key" : "PRODUCT_OWNER"
            }, {
            "description" : "Product Owner Company",
            "key" : "PRODUCT_OWNER_COMP"
            }, {
            "description" : "Project Team",
            "key" : "PROJECT_TEAM"
            }, {
            "description" : "Prospect",
            "key" : "PROSPECT"
            }, {
            "description" : "Provider Accounting",
            "key" : "PROVIDER_ACCOUNTING"
            }, {
            "description" : "Provider Analyst",
            "key" : "PROVIDER_ANALYST"
            }, {
            "description" : "Provider Functional",
            "key" : "PROVIDER_FUNCTIONAL"
            }, {
            "description" : "Provider Manager",
            "key" : "PROVIDER_MANAGER"
            }, {
            "description" : "Provider Tester",
            "key" : "PROVIDER_TESTER"
            }, {
            "description" : "Provider Validator",
            "key" : "PROVIDER_VALIDATOR"
            }, {
            "description" : "Receiver",
            "key" : "RECEIVER"
            }, {
            "description" : "Referrer",
            "key" : "REFERRER"
            }, {
            "description" : "Regulatory Agency",
            "key" : "REGULATORY_AGENCY"
            }, {
            "description" : "Request Manager",
            "key" : "REQ_MANAGER"
            }, {
            "description" : "Request Respondent",
            "key" : "REQ_RESPOND"
            }, {
            "description" : "Request Role",
            "key" : "REQUEST_ROLE"
            }, {
            "description" : "Request Taker",
            "key" : "REQ_TAKER"
            }, {
            "description" : "Requesting Party",
            "key" : "REQ_REQUESTER"
            }, {
            "description" : "Reviewer",
            "key" : "REVIEWER"
            }, {
            "description" : "SCRUM Master",
            "key" : "SCRUM_MASTER"
            }, {
            "description" : "SCRUM Team",
            "key" : "SCRUM_TEAM"
            }, {
            "description" : "Sales Force Autm.",
            "key" : "SFA_ROLE"
            }, {
            "description" : "Sales Representative",
            "key" : "SALES_REP"
            }, {
            "description" : "Scrum Member",
            "key" : "SCRUM_MEMBER"
            }, {
            "description" : "Shareholder",
            "key" : "SHAREHOLDER"
            }, {
            "description" : "Ship-From Vendor",
            "key" : "SHIP_FROM_VENDOR"
            }, {
            "description" : "Ship-To Customer",
            "key" : "SHIP_TO_CUSTOMER"
            }, {
            "description" : "Shipment Clerk",
            "key" : "SHIPMENT_CLERK"
            }, {
            "description" : "Sponsor",
            "key" : "SPONSOR"
            }, {
            "description" : "Spouse",
            "key" : "SPOUSE"
            }, {
            "description" : "Stakeholder",
            "key" : "STAKEHOLDER"
            }, {
            "description" : "Stocker",
            "key" : "STOCKER"
            }, {
            "description" : "Subscriber",
            "key" : "SUBSCRIBER"
            }, {
            "description" : "Subsidiary",
            "key" : "SUBSIDIARY"
            }, {
            "description" : "Supplier",
            "key" : "SUPPLIER"
            }, {
            "description" : "Supplier Agent",
            "key" : "SUPPLIER_AGENT"
            }, {
            "description" : "Tax Authority",
            "key" : "TAX_AUTHORITY"
            }, {
            "description" : "Union",
            "key" : "UNION"
            }, {
            "description" : "Vendor",
            "key" : "VENDOR"
            }, {
            "description" : "Visitor",
            "key" : "VISITOR"
            }, {
            "description" : "Web Master",
            "key" : "WEB_MASTER"
            }, {
            "description" : "Worker",
            "key" : "WORKER"
            }, {
            "description" : "Workflow",
            "key" : "WORKFLOW_ROLE"
            }, {
            "description" : "Workflow Owner",
            "key" : "WF_OWNER"
            } ],
            "disabled" : "false",
            "id" : "EditCarrierShipmentMethod_roleTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "roleTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Seq. Num.",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "sequenceNumber",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditCarrierShipmentMethod_sequenceNumber",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "40",
            "tabindex" : "",
            "className" : "",
            "title" : "Carrier Service Code",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "carrierServiceCode",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditCarrierShipmentMethod_carrierServiceCode",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditCarrierShipmentMethod",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "EditCarrierShipmentMethod_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Submit",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createCarrierShipmentMethod"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "partyId", "roleTypeId", "geoIdFrom", "geoIdTo", "fromDate", "thruDate", "leadTime", "leadTimeUomId", "editLink", "expireLink" ]
        } ],
        "columns" : [ {
            "name" : "shipmentMethodTypeId",
            "title" : "Shipment Method Type ID"
        }, {
            "name" : "partyId",
            "title" : "Party ID"
        }, {
            "name" : "roleTypeId",
            "title" : "Role Type ID"
        }, {
            "name" : "geoIdFrom",
            "title" : "Geo Id From"
        }, {
            "name" : "geoIdTo",
            "title" : "Geo Id To"
        }, {
            "name" : "fromDate",
            "title" : "From Date"
        }, {
            "name" : "thruDate",
            "title" : "Through Date"
        }, {
            "name" : "leadTime",
            "title" : "Lead Time"
        }, {
            "name" : "leadTimeUomId",
            "title" : "Lead Time Uom ID"
        }, {
            "name" : "editLink",
            "title" : " "
        }, {
            "name" : "expireLink",
            "title" : " "
        } ],
        "formName" : "ListShipmentTimeEstimates",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/ShippingForms.xml",
        "type" : "list",
        "fields" : [ {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "shipmentMethodTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListShipmentTimeEstimates_shipmentMethodTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyId",
            "description" : "",
            "style" : "",
            "id" : "ListShipmentTimeEstimates_partyId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "roleTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListShipmentTimeEstimates_roleTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "geoIdFrom",
            "description" : "",
            "style" : "",
            "id" : "ListShipmentTimeEstimates_geoIdFrom",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "geoIdTo",
            "description" : "",
            "style" : "",
            "id" : "ListShipmentTimeEstimates_geoIdTo",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "fromDate",
            "description" : "",
            "style" : "",
            "id" : "ListShipmentTimeEstimates_fromDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "thruDate",
            "description" : "",
            "style" : "",
            "id" : "ListShipmentTimeEstimates_thruDate",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "leadTime",
            "description" : "",
            "style" : "",
            "id" : "ListShipmentTimeEstimates_leadTime",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "leadTimeUomId",
            "description" : "",
            "style" : "",
            "id" : "ListShipmentTimeEstimates_leadTimeUomId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "editLink",
            "alternate" : "",
            "description" : "Edit",
            "parameterList" : [ ],
            "id" : "ListShipmentTimeEstimates_editLink",
            "imageTitle" : "",
            "parameterMap" : {
            "fromDate" : "null",
            "geoIdFrom" : "null",
            "sequenceNumber" : "null",
            "roleTypeId" : "null",
            "leadTimeUomId" : "null",
            "leadTime" : "null",
            "partyId" : "null",
            "shipmentMethodTypeId" : "null",
            "geoIdTo" : "null",
            "thruDate" : "null"
            },
            "height" : "",
            "target" : "ListShipmentTimeEstimates"
        }, {
            "image" : "",
            "width" : "",
            "name" : "expireLink",
            "alternate" : "",
            "description" : "Expire",
            "parameterList" : [ ],
            "id" : "ListShipmentTimeEstimates_expireLink",
            "imageTitle" : "",
            "parameterMap" : {
            "fromDate" : "null",
            "geoIdFrom" : "null",
            "roleTypeId" : "null",
            "partyId" : "null",
            "shipmentMethodTypeId" : "null",
            "geoIdTo" : "null"
            },
            "height" : "",
            "target" : "expireShipmentTimeEstimate"
        } ],
        "target" : ""
    },
    {
        "formName" : "EditShipmentTimeEstimate",
        "altTarget" : [ {
            "useWhen" : "shipmentTimeEstimate != null",
            "targetExdr" : {
            "chars" : "updateShipmentTimeEstimate",
            "hint" : 20,
            "empty" : false,
            "original" : "updateShipmentTimeEstimate"
            }
        } ],
        "formLocation" : "component://kwikstore/widget/ShippingForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "shipmentMethodTypeId",
            "action" : "",
            "id" : "EditShipmentTimeEstimate_shipmentMethodTypeId",
            "type" : "DISPLAY_ENTITY",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "partyId",
            "action" : "",
            "id" : "EditShipmentTimeEstimate_partyId",
            "type" : "DISPLAY_ENTITY",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "roleTypeId",
            "action" : "",
            "id" : "EditShipmentTimeEstimate_roleTypeId",
            "type" : "DISPLAY_ENTITY",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "shipmentMethodTypeId",
            "description" : "",
            "style" : "",
            "id" : "EditShipmentTimeEstimate_shipmentMethodTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyId",
            "description" : "",
            "style" : "",
            "id" : "EditShipmentTimeEstimate_partyId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "roleTypeId",
            "description" : "",
            "style" : "",
            "id" : "EditShipmentTimeEstimate_roleTypeId",
            "title" : "",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditShipmentTimeEstimate",
            "id" : "EditShipmentTimeEstimate_geoIdTo",
            "event" : "",
            "value" : "_NA_",
            "fieldFormName" : "LookupGeo",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "geoIdTo",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "geoIdTo",
            "style" : "",
            "id" : "EditShipmentTimeEstimate_geoIdTo",
            "title" : "Geo Id To",
            "type" : "LOOKUP"
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "EditShipmentTimeEstimate",
            "id" : "EditShipmentTimeEstimate_geoIdFrom",
            "event" : "",
            "value" : "_NA_",
            "fieldFormName" : "LookupGeo",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "geoIdFrom",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "geoIdFrom",
            "style" : "",
            "id" : "EditShipmentTimeEstimate_geoIdFrom",
            "title" : "Geo Id From",
            "type" : "LOOKUP"
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "From Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-04-13%2013:15:17.645",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditShipmentTimeEstimate",
            "timeDropdownParamName" : "fromDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditShipmentTimeEstimate_fromDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "fromDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2023-04-13%2013:15:17.645",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "EditShipmentTimeEstimate",
            "timeDropdownParamName" : "thruDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "EditShipmentTimeEstimate_thruDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "thruDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "required",
            "title" : "Lead Time",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "leadTime",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditShipmentTimeEstimate_leadTime",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Lead Time Uom ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "TF_day",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditShipmentTimeEstimate",
            "options" : [ {
            "description" : "Time in Milli-Seconds",
            "key" : "TF_ms"
            }, {
            "description" : "Time in Seconds",
            "key" : "TF_s"
            }, {
            "description" : "Time in Minutes",
            "key" : "TF_min"
            }, {
            "description" : "Time in Hours",
            "key" : "TF_hr"
            }, {
            "description" : "Time in Days",
            "key" : "TF_day"
            }, {
            "description" : "Time in Weeks",
            "key" : "TF_wk"
            }, {
            "description" : "Time in Months",
            "key" : "TF_mon"
            }, {
            "description" : "Time in Years",
            "key" : "TF_yr"
            }, {
            "description" : "Time in Decades",
            "key" : "TF_decade"
            }, {
            "description" : "Time in Scores",
            "key" : "TF_score"
            }, {
            "description" : "Time in Centuries",
            "key" : "TF_century"
            }, {
            "description" : "Time in Millenia",
            "key" : "TF_millenium"
            } ],
            "disabled" : "false",
            "id" : "EditShipmentTimeEstimate_leadTimeUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "leadTimeUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "EditShipmentTimeEstimate",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "EditShipmentTimeEstimate_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Submit",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "createShipmentTimeEstimate"
    }
]